module.exports = __webpack_public_path__ + "static/media/get-involved-stay-connected-1.0faacbfa.png";